module.exports = __webpack_public_path__ + "img/whatsapp.b893a69c.svg";